export enum MedicalCareType {
    MEDICAL_EXAMINATION = 'MEDICAL_EXAMINATION',
    CHRONIC_CONDITION = 'CHRONIC_CONDITION',
    SYSTEMATIC_EXAMINATION = 'SYSTEMATIC_EXAMINATION',
}
